import { useState } from "react";
import { PackageIcon as Package } from "@phosphor-icons/react";

const BRAND_DOMAINS = [
  { kw: ["office 365", "office365", "microsoft 365", "m365", "office", "microsoft", "windows", "azure", "outlook", "exchange", "teams", "onedrive", "sharepoint"], domain: "microsoft.com" },
  { kw: ["fotocopiatrice", "copiatrice", "multifunzione", "stampante", "stampanti", "mfp", "plotter", "ricoh"], domain: "ricoh.com" },
  { kw: ["sophos"], domain: "sophos.com" },
  { kw: ["zyxel"], domain: "zyxel.com" },
  { kw: ["fortinet", "fortigate"], domain: "fortinet.com" },
  { kw: ["watchguard"], domain: "watchguard.com" },
  { kw: ["hp ", "hewlett", "hpe"], domain: "hp.com" },
  { kw: ["dell"], domain: "dell.com" },
  { kw: ["lenovo"], domain: "lenovo.com" },
  { kw: ["veeam"], domain: "veeam.com" },
  { kw: ["acronis"], domain: "acronis.com" },
  { kw: ["aruba"], domain: "aruba.it" },
  { kw: ["vmware"], domain: "vmware.com" },
  { kw: ["synology"], domain: "synology.com" },
  { kw: ["qnap"], domain: "qnap.com" },
  { kw: ["ubiquiti", "unifi"], domain: "ui.com" },
  { kw: ["cisco"], domain: "cisco.com" },
  { kw: ["google", "workspace", "gmail"], domain: "google.com" },
  { kw: ["kaspersky"], domain: "kaspersky.com" },
  { kw: ["eset"], domain: "eset.com" },
  { kw: ["bitdefender"], domain: "bitdefender.com" },
  { kw: ["wildix"], domain: "wildix.com" },
  { kw: ["3cx"], domain: "3cx.com" },
];

function matchDomain(name) {
  const n = (name || "").toLowerCase();
  for (const b of BRAND_DOMAINS) {
    if (b.kw.some((k) => n.includes(k))) return b.domain;
  }
  return null;
}

export function BrandLogo({ name, size = 22 }) {
  const [err, setErr] = useState(false);
  const domain = matchDomain(name);
  if (!domain || err) {
    return <Package size={size} weight="duotone" className="text-muted-foreground shrink-0" data-testid="brand-logo-fallback" />;
  }
  return (
    <img
      src={`https://logo.clearbit.com/${domain}`}
      alt={name}
      width={size}
      height={size}
      onError={() => setErr(true)}
      className="rounded-sm object-contain shrink-0 bg-white"
      data-testid="brand-logo"
    />
  );
}
